import { FC } from "react";
import { Switch, Route, Redirect } from "react-router";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Link,
  Tabs,
  TabList,
  TabLink,
  useBreakpointValue,
  useRouteTabs,
} from "Shared";

import { PageApp } from "Components/PageApp";
import { useClassContext } from "Components/LayoutClass";
import { PageHeader } from "Components/PageHeader";

import { Submissions } from "Pages/AdminDashboard/AdminSubmissions/Submissions";
import { AdminCommentsV2 } from "Pages/AdminDashboard/AdminComments/AdminCommentsV2";

export const ClassroomModeration: FC = () => {
  const { classData } = useClassContext();
  const showBreadcrumb = useBreakpointValue({ base: true, lg: false });

  const { tabsProps } = useRouteTabs({
    routes: [
      { path: `/class/${classData.id}/moderation/comments` },
      { path: `/class/${classData.id}/moderation/projects` },
    ],
  });

  return (
    <Tabs {...tabsProps} isManual>
      <PageApp>
        <PageHeader
          title="Moderation"
          showBreadcrumb={showBreadcrumb}
          renderBreadcrumb={
            <Breadcrumb>
              <BreadcrumbItem>
                <BreadcrumbLink as={Link} to={`/class/${classData.id}/`}>
                  {classData.name}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink>Moderation</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          }
          renderTabs={
            <TabList>
              <TabLink to={`/class/${classData.id}/moderation/comments`}>
                Comments
              </TabLink>
              <TabLink to={`/class/${classData.id}/moderation/projects`}>
                Projects
              </TabLink>
            </TabList>
          }
        />
        <Switch>
          <Route path={`/class/:classId/moderation/comments`}>
            <AdminCommentsV2 learnerGroupId={classData.id} />
          </Route>
          <Route path={`/class/:classId/moderation/projects`}>
            <Submissions learnerGroupId={classData.id} />
          </Route>
          <Redirect to={`/class/${classData.id}/moderation/comments`} />
        </Switch>
      </PageApp>
    </Tabs>
  );
};
